

type Size = "xs" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl"


export const spacing = (size: Size) => {
    return `var(--spacing-${size}-n)`
}